import React from 'react';
import './RegionSelector.css';

const REGION_ICONS = {
  upper: '▲',
  face: '●',
  lower: '▼',
};

const RegionSelector = ({ value, onChange, options = [
  { label: 'Upper Band', value: 'upper' },
  { label: 'Face', value: 'face' },
  { label: 'Lower Band', value: 'lower' },
], disabled = false, multiSelect = false }) => {
  const handleChange = (regionValue) => {
    if (disabled) return;
    if (multiSelect) {
      const newValue = Array.isArray(value) ? [...value] : [];
      if (newValue.includes(regionValue)) {
        newValue.splice(newValue.indexOf(regionValue), 1);
      } else {
        newValue.push(regionValue);
      }
      onChange(newValue);
    } else {
      onChange(regionValue);
    }
  };

  return (
    <div className={`region-selector ${multiSelect ? 'region-selector--multi' : ''}`} role={multiSelect ? 'group' : 'radiogroup'} aria-label="Select region">
      {options.map((option) => {
        const optionValue = typeof option === 'string' ? option : option.value;
        const optionLabel = typeof option === 'string' ? option : option.label;
        const isSelected = multiSelect 
          ? Array.isArray(value) && value.includes(optionValue)
          : value === optionValue;
        return (
          <label
            key={optionValue}
            className={`region-option ${isSelected ? 'region-option--active' : ''} ${
              disabled ? 'region-option--disabled' : ''
            }`}
          >
            <input
              type={multiSelect ? 'checkbox' : 'radio'}
              name={multiSelect ? undefined : 'region'}
              value={optionValue}
              checked={isSelected}
              onChange={() => handleChange(optionValue)}
              disabled={disabled}
              className="region-option__input"
            />
            <span className="region-option__icon" aria-hidden="true">
              {REGION_ICONS[optionValue] || '○'}
            </span>
            <span className="region-option__label">
              {optionLabel}
            </span>
          </label>
        );
      })}
    </div>
  );
};

export default RegionSelector;
